var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("กรุณารอสักครู่.....")]),(_vm.htmlContent)?_c('iframe',{attrs:{"src":_vm.htmlContent,"width":"1000","height":"600"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }